export function sortByColumn(bodyData, columnName) {
  console.log(bodyData);
  return bodyData.sort((a, b) => {
    return a[columnName].localeCompare(b[columnName], 'en', {
      numeric: true,
      sensitivity: 'base',
    });
  });
}
